import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/** The type scale in globals.css. Without it tailwind-merge reads `text-small` as a colour and
 *  drops it when a `text-ink-*` colour follows. */
export const TYPE_SCALE = [
  'micro',
  'caption',
  'small',
  'body',
  'lead',
  'title',
  'headline',
  'display',
  'hero',
  'mega',
] as const

const twMerge = extendTailwindMerge({
  extend: { theme: { text: [...TYPE_SCALE] } },
})

/** Merge class names, resolving Tailwind conflicts (later classes win). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
